import LoadingIndicator from 'app/components/LoadingIndicator';
import PayverseHeader from 'app/components/PayverseHeader';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

// Wechat 설치 여부 판단하여
// payUrl을 Iframe으로 띄우고
// Iframe 실행하는 동안 대기했다가.
// Iframe의 page가 Webserver를 통과한 결과 페이지ㅕㅁㄴ
// 부모의 페이지에서 confirm으로 가서
// 결과처리

// 사용자 디바이스의 OS에 맞춰 리디렉션 URL 반환
const getFailRedirectUrl = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/iphone|ipod/.test(userAgent)) {
    // iOS 디바이스일 경우 App Store로 리디렉션
    return 'https://apps.apple.com/app/wechat/id414478124';
  } else if (/android/.test(userAgent)) {
    // Android 디바이스일 경우 Google Play로 리디렉션
    return 'https://play.google.com/store/apps/details?id=com.tencent.mm';
  } else {
    // 다른 플랫폼은 기본적으로 Google Play로 리디렉션
    return 'https://play.google.com/store/apps/details?id=com.tencent.mm';
  }
};

const WechatOpen = () => {
  const { t } = useTranslation();
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const { setPaymentState } = usePaymentState();

  const [tid, setTid] = useState<string>();
  const [wechatPayUrl, setWechatPayUrl] = useState<string>();

  useEffect(() => {
    const paramTid = new URLSearchParams(searchParams).get('tid');
    const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');
    if (paramPayUrl && paramTid) {
      setWechatPayUrl(paramPayUrl);
      setTid(paramTid);
      setPaymentState(prevState => ({
        ...prevState,
        tid: paramTid,
        // returnUrl: returnUrl,
      }));
    }
  }, [searchParams]);

  useEffect(() => {
    if (wechatPayUrl) {
      window.location.href = wechatPayUrl;
    }
  }, [wechatPayUrl]);

  // function isMyApp(): void {
  //   let heartbeat: number;
  //   let timer: number;

  //   // 타이머를 클리어하는 함수
  //   function clearTimers(): void {
  //     clearInterval(heartbeat);
  //     clearTimeout(timer);
  //   }

  //   // 주기적으로 숨김 상태를 체크하여 앱이 설치되었는지 확인
  //   function intervalHeartbeat(): void {
  //     if (document.webkitHidden || document.hidden) {
  //       clearTimers();
  //       console.log('앱이 설치 되어 있습니다.');
  //     }
  //   }

  //   heartbeat = setInterval(intervalHeartbeat, 200);

  //   const delay = 1000;
  //   timer = setTimeout(() => {
  //     console.log('앱이 없습니다.');
  //     clearTimers();
  //   }, delay);
  // }

  return (
    <div className="payverse-wrap">
      <div className="payverse">
        <PayverseHeader />
        <LoadingIndicator />
        <div className="d-section">
          <div className="box">
            <div className="copy">
              Copyright (c) eromnet Co., Ltd. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WechatOpen;
